"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBalances = getBalances;
exports.getAllBalances = getAllBalances;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
async function getBalances(owner, tokenNames) {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const allBalances = await suiClient.getAllBalances({
        owner: owner,
    });
    const selectedCoins = Object.values(alphafi_sdk_1.coinsList).filter((coin) => tokenNames.includes(coin.name));
    const coinTypes = selectedCoins.map((coin) => coin.type);
    const balances = allBalances
        .filter((balance) => coinTypes.includes(balance.coinType))
        .map((balance) => {
        const coin = selectedCoins.find((coin) => coin.type === balance.coinType);
        return {
            tokenName: coin ? coin.name : "Unknown",
            balance: balance.totalBalance,
        };
    });
    return balances;
}
async function getAllBalances(owner) {
    const suiClient = (0, alphafi_sdk_1.getSuiClient)();
    const allBalances = await suiClient.getAllBalances({ owner });
    const balances = allBalances.map((balance) => {
        const coin = Object.values(alphafi_sdk_1.coinsList).find((coin) => coin.type.toLowerCase() === balance.coinType.toLowerCase());
        if (balance.coinType === "0x2::sui::SUI") {
            return {
                tokenName: "SUI",
                balance: balance.totalBalance,
            };
        }
        return {
            tokenName: coin ? coin.name : "Unknown",
            balance: balance.totalBalance,
        };
    });
    return balances;
}
//# sourceMappingURL=balance.js.map